import React, { useCallback, useState } from 'react';
import { Trans } from 'react-i18next';

import { useAppSelector } from '@common/hooks/redux';
import { useCelebrations } from '@common/hooks/use-celebrations';
import Spinner from '@common/components/spinner';

import CelebrationsModal from './celebrations-modal';
import { network } from '@modules/core/selectors/logged-user';
import CelebrationsWidgetCard from './celebrations-widget-card';

export const CelebrationsWidget = () => {
  const selectedNetwork = useAppSelector(network);

  const [showModal, setShowModal] = useState<boolean>(false);
  const { celebrations, loading } = useCelebrations({ network_ids: [selectedNetwork.id] });

  const toggleModal = useCallback(() => {
    setShowModal(!showModal);
  }, [showModal]);

  return (
    <div className="celebrations-widget-container">
      <div className="balloon celebrations-widget">
        <h5 className="balloon__title">
          <span><Trans i18nKey="social:celebrations_card_title" />
            {celebrations.length > 0 && <small>{celebrations.length}</small>}
          </span>
          <div className="pull-right">
            <a onClick={toggleModal}>
              <Trans i18nKey="social:view_birthdays" />
            </a>
          </div>
        </h5>

        {loading ? (
          <Spinner centered />
          ) : (
            <>
              {celebrations.length > 0 ? null
              : (
                <p className="tw-text-gray-custom-700 tw-text-center tw-mt-[30px]">
                  <Trans i18nKey="social:no_celebrations_today" />
                </p>
              )}
              {celebrations.slice(0, 3).map((celebration) => (
                <CelebrationsWidgetCard
                  key={celebration.id}
                  user={celebration}
                  view={celebration.type}
                />
              ))}
            </>
          )}
      </div>
      {showModal && (
      <CelebrationsModal open={showModal} onClose={toggleModal} networkIds={[selectedNetwork.id]} />
        )}
    </div>
  );
};
